export const LRS_END_POINT = "https://saas.learninglocker.net:443/data/xAPI/";
export const LRS_KEY = "7473bd5b16d9285e2eaec3bdb55d0914535453ed";
export const LRS_SECRET = "f6b15929418591de550b33a7133be3b3a12bfb46";
export const LRS_ALLOW_FAIL = false;

export const OBJECT_TYPE_AGENT = "Agent";
export const OBJECT_TYPE_GROUP = "Group";

export const ACTOR = {
    objectType: OBJECT_TYPE_AGENT,
    name: "Adam Steff",
    account :{
        name: "145",
        homePage: "http://www.gurooproducer.com"
    }
};

export const TARGET = "http://www.gurooproducer.com/72/video";

export const ACTIVITY_URL_ID = "http://www.gurooproducer.com/activitiy";


export const KPI_CODE = "kpi";
export const KPI_LABEL = "KPI";

export const BADGE_CODE = "badge";
export const BADGE_LABEL = "Badge";

export const EXPERIENCE_CODE = "learning_experience";
export const EXPERIENC_LABEL = "Learning Experience";

export const BITE_CODE = "learning_bite";
export const BITE_LABEL = "Learning Bite";

export const SCREEN_CODE = "screen";
export const SCREEN_LABEL = "Screen";

export const SUB_SCREEN_CODE = "sub_screen";
export const SUB_SCREEN_LABEL = "Sub Screen";

export const PROJECT_ACTIVITY_TYPE = "http://id.tincanapi.com/activitytype/project-site";
export const MODULE_ACTIVITY_TYPE = "http://adlnet.gov/expapi/activities/module";
export const SECTION_ACTIVITY_TYPE = "http://id.tincanapi.com/activitytype/section";
export const OBJECTIVE_ACTIVITY_TYPE = "http://adlnet.gov/expapi/activities/objective";
export const BADGE_ACTIVITY_TYPE = "http://activitystrea.ms/schema/1.0/badge";
export const QUESTION_ACTIVITY_TYPE = "http://adlnet.gov/expapi/activities/question";
export const PAGE_ACTIVITY_TYPE = "http://activitystrea.ms/schema/1.0/page";


/** WEBPACK FOOTER **
 ** ./src/constants/xAPIConstants.js
 **/